import { VideoControlWrapper as VideoControl } from '../../session/controls/VideoControlWrapper';
import { useOpenHelpModalCallback } from './useOpenHelpModalCallback';

export function ProviderVideoControlWrapper() {
  const openHelpModal = useOpenHelpModalCallback();

  return <VideoControl openHelpModal={openHelpModal} />;
}
